import {type ComponentType, Suspense} from 'react';

import {PageLoading} from '@src/v2/components/PageLoading';

export const Loadable =
  <P extends object>(Component: ComponentType<P>, fallback = <PageLoading />) =>
  (props: P) => (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );
